import { DatePipe } from "@angular/common";
import {
  Component,
  EventEmitter,
  Input,
  Output,
  ViewChild,
} from "@angular/core";
import { FormControl } from "@angular/forms";
import { Store } from "@ngrx/store";
import { ToasterService } from "angular2-toaster";
import { BsModalRef, BsModalService } from "ngx-bootstrap";
import * as $ from "jquery";
import * as _ from "lodash";
import "rxjs/add/operator/map";
import "rxjs/add/operator/startWith";
import swal from "sweetalert2";
import * as fromRootStore from "../../../../reducers";
import { SalesInvoiceService } from "../../../../services/salesinvoice.service";
import { SalesOrderService } from "../../../../services/salesOrder.service";
import { MenuMappingService } from "../../../../services/menuMapping.service";
import { PrintData } from "../../../master/print/print";
// import { style } from "@angular/core/src/animation/dsl";

@Component({
  selector: "addEditInvoice",
  templateUrl: "./addcounterDC.html",
})
export class addcounterDC {
  @ViewChild("tbody1") tbody1;
  row: any;
  data: any;
  designdata: any = { indent_no: 0, totalmtr: 0, totalamt: 0 };
  qualityList: any;
  typeList: any;
  colorList: any;
  codeList: any;
  rawdata:any;
  seasonList: any;
  widthList: any[];
  execApi: boolean = true;
  menu : any;
  scanned_by : any;
  invoicedata: any = {
    rate_type: "",
    invoice_type: "",
    corcharge: 0,
    boxless: 0,
    taxper: 5,
    disper: 0,
    salesorder: false,
    rate: 0,
    no_of_bundles: 0,
    remarks: '',
    narration: ''
  };
  delPartyList: any;
  party_id: any;
  box: any;
  desData: any = {
    totalmtr: 0,
    totalamt: 0,
  };
  designList: any;
  invalidList: any = [];
  invoiceTypeList = ["ESTIMATE", "INVOICE"];
  rateTypeList = ["FLAT RATE", "DISCOUNT"];
  mode: string;
  saveEvent: any;
  agentList: any;
  bl = [];
  partyCodeList: any;
  isLoading: boolean = false;
  isChecked: boolean = false;
  sampleList = [{ name: "YES" }, { name: "NO" }];
  partyList: any;
  partyOrderno: any;
  order: any;
  page_type: any;
  bagged_pcs: number= 0;
  bag_id : number = 0;
  expand = true;
  menu_name : any
  to_sale_type: any;
  listSelected = [];
  printData;
  isLoadMask: Promise<any>;
  @Input() _params: any;

  @Input() set params(val: any[]) {
    if (_.isEmpty(val)) {
      let row: any = {};
      row.tabevent = new EventEmitter();
      let tabObj = {
        action: "NewTab",
        params: {
          //  tabParent: 'Transaction',
          tabName: "BARCODE TRACKING",
          title: "BARCODE TRACKING",
          tabParent: "WAREHOUSE",
          mode: "Add",
          data: row,
          name: "BARCODE TRACKING",
          sale_type: this.menu.param == "barcode_active" ? "barcode_active" : "tracking",
        },
      };
      console.log(this.menu.param)
      this._params = tabObj;
      val = this._params;
      this.mode = tabObj.params.mode
      this.page_type = tabObj.params.sale_type
  
      this.saveEvent = row.tabevent;
      let invoicedata = Object.assign({}, tabObj.params["data"]);
      this.invoicedata = invoicedata;
    }
    else {
      this._params = val;
      this.mode = val["mode"];

      this.page_type = val["sale_type"];
      // this.to_sale_type = val["to_sale_type"];
      this.saveEvent = val["data"].tabevent;
      let invoicedata = Object.assign({}, val["data"]);

      this.invoicedata = invoicedata;
      this.invoicedata.disper = invoicedata.disper;

      if(val["title"] == "ADD COUNTER DC" || val["title"]== "EDIT COUNTER DC"){
         this.menu_name ="Counter"
      }
      if (this.mode == "Convert") {
        this.invoicedata.mode = "Add";
      }

      if (this.mode == "Convert") {
        //  this.editInvoiceList();
        this.invoicedata.dcdt = this.datePipe.transform(new Date(), "yyyy-MM-dd");
        //   this.oncheck(this.invoicedata.salesorder);
      }
      if (
        this.mode == "Convert" ||
        this.mode == "Edit" ||
        this.mode == "View" ||
        this.mode == "Inwarded"
      ) {
      
        this.invoicedata.boxless = Number(this.invoicedata.boxless);
        this.editInvoiceList();
        this.barcodeList();
        //    this.invoicedata.dcdt = this.datePipe.transform(new Date(), 'yyyy-MM-dd');
        this.oncheck(this.invoicedata.salesorder);
      }
    }
  }

  get params(): any[] {
    return this._params;
  }
  @Output() tabUpdateEvent = new EventEmitter();
  @ViewChild("widthAuto") widthAuto;
  @ViewChild("codeAuto") codeAuto;
  widthCtrl: FormControl = new FormControl();
  partyCtrl: FormControl = new FormControl();
  OrderNoCtrl: FormControl = new FormControl();
  qualityCtrl: FormControl = new FormControl();
  invdtControl: FormControl = new FormControl();
  parentCtrl: FormControl = new FormControl();
  constructor(
    public store: Store<fromRootStore.State>,
    private salesinvservice: SalesInvoiceService,
    private Salesservice: SalesOrderService,
    private MappingService : MenuMappingService,
    private modalService: BsModalService,
    public datePipe: DatePipe,
    public toasterService: ToasterService
  ) {
    this.row = {
      //  po_id: 0,
      design_no: "",
      shade: "",
      quality: "",
      type: "",
      color: "",
      sample_cut: "NO",
      swatch_cut: "NO",
      act_color: "",
      width: "",
      qty: 0,
      mtrs: 0,
      rate: 0,
      amount: 0,
    };
    this.data = {
      invoiceList: [],
    };
  }
  ngOnInit() {
    //(<any>$("#tableres")).colResizable({liveDrag:true});

    this.getSalesParty();
    this.getUserList()
    this.getSeason();
    this.tableScroll();
    this.invoicedata.mode = this.mode;
    this.invoicedata.sales_type = this.page_type;

    if (this.mode == "Add") {
      this.invoicedata.dcdt = this.datePipe.transform(new Date(), "yyyy-MM-dd");
      this.invoicedata.taxper = 5;
      this.invoicedata.boxless = 0;
      this.invoicedata.no_of_bundles = 0;

      this.getAutoNumber();
      //this.getAuto();
    }
    if (this.mode == "Convert") {
      // this.convertAutoNumber();

      // if (this.to_page_type == "proformaWholesale") {

      //   this.invoicedata.taxper = 0;
      // }

    }
  }
  ngAfterViewInit() {
    if (this.page_type == "retail") {
      setTimeout(() => {
        $("#invoice_type").focus();
      }, 100);
    } else {
      setTimeout(() => {
        $("#partyname").focus();
      }, 100);
    }
  }
  tableScroll() {
    $(".invoiceTable").height(window.innerHeight - 400);
    $(".invoiceTable").width(window.innerWidth - 30);
  }

  onEnterKeyPressed(nextEl: string) {
    if ($(".swal2-container").length > 0) {
      return false;
    } else {
      // let a = $(".mat-autocomplete-panel.mat-autocomplete-visible");
      // a.removeClass('mat-autocomplete-visible');
      setTimeout(() => {
        $("#" + nextEl).focus();
      }, 500);
    }
  }

  onGoToNextFld($event, fld, ind) {
    let nxtInd = ind;
    let nxtRow = $("#row-" + ind).next("tr");
    if (fld == "bar" && nxtRow.length == 0) {
      let rowdetail = Object.assign({}, this.row);
      nxtInd = nxtInd + 1;
      $("#" + "bar" + "-" + nxtInd).focus();
    } else {
      setTimeout(() => {
        let a = $(".mat-autocomplete-panel.mat-autocomplete-visible");
        a.removeClass("mat-autocomplete-visible");
        $("#" + fld + "-" + nxtInd).focus();
      }, 100);
    }
  }

  isRowEmpty(ind) {
    let data = this.data.invoiceList;
    for (let i = 0; i < data.length; i++) {
      if (data[i + 1].design_no != "") {
        return true;
      } else {
        return false;
      }
    }
  }
  onDeleteRow($event, fld, ind) {
    $event.preventDefault();
    let that = this;


    swal({
      title: "Are you sure to delete this row?",
      type: "warning",
      focusCancel: true,
      showCancelButton: true,
      confirmButtonText: "Yes, Delete it!",
      cancelButtonText: "No, want to change",
    }).then(
      function () {
        that.invoicedata.dcid = that.data.invoiceList[ind].dcid;
        that.invoicedata.barcode = that.data.invoiceList[ind].barcode;

        that.data.invoiceList.splice(ind, 1);

        if (that.menu_name == 'Counter' && that.bagged_pcs) {
          that.bagged_pcs = that.bagged_pcs + 1;
          that.bag_id = (that.bagged_pcs > 0) ? that.bag_id : 0;
     
        }
        that.calctot();

        let params: any = Object.assign({}, that.invoicedata);
        params["tabevent"] = undefined;
      
        that.isLoadMask = that.Salesservice
          .DeletecounterDC(params)
          .then(function (res: any) {
            if (res.success) {
              that.toasterService.pop({
                bodyOutputType: 1,
                type: "success",
                title: "SUCCESS",
                body: res.message,
              });
            }
            else {
              swal("ERROR", res.message, "error");
            }
          })
      },
      function (dismiss) { }
    );
  }
  checkAll(evant, all) {
    if (evant.target.checked) {
      this.listSelected = this.data.invoiceList;
      $("input:checkbox").prop("checked", evant.target.checked);
    } else {
      $("input:checkbox").prop("checked", evant.target.checked);
      this.listSelected = [];
    }
  }
  checkInd(evant, ind, all) {
    if (evant.target.checked) {
      this.listSelected.push(all.data.invoiceList[ind]);
    } else {
      for (var k = 0; k < this.listSelected.length; k++) {
        if (this.listSelected[k].barcode == all.data.invoiceList[ind].barcode) {
          this.listSelected.splice(k, 1);
          return;
        }
      }
    }
  }

  onGoToUpAndDown($event, fld, arrow, ind) {
    if ($(".mat-autocomplete-panel.mat-autocomplete-visible").length > 0) {
      return false;
    }
    $event.preventDefault();
    if ($("typeahead-container").length > 0) {
      return false;
    }
    if (arrow == "up") ind--;
    else ind++;

    if ($("#" + fld + "-" + ind).length > 0) {
      $("#" + fld + "-" + ind).focus();
    }
  }

  getAutoNumber() {
    let params = {
      trans_type: 'counterdc',
      date: this.datePipe.transform(new Date(), "yyyy-MM-dd"),
    };


    this.salesinvservice.getAutoNumber(params).then((res: any) => {
      this.invoicedata.dc_no = res.auto_no;
    });

  }
  getSalesParty() {
    let params = {
      start: 0,
      limit: 100,
      page: 1,
    };
    this.salesinvservice.getSalesParty(params).then((res: any) => {
      this.partyList = res;
      if (this.page_type == "retail") {
        this.invoicedata.party_name = "RETAIL";
      }
      this.onSelectPartyName(this.invoicedata.party_name);
    });
  }
    BagStyle(ind) {
       if (this.data.invoiceList[ind].bag_barcode) {
      return {
        color: "green",
        fontWeight: "800"
      };
    }
  }

  getUserList(){
    this.MappingService.getUserList({}).then((res: any) => {
      this.scanned_by = res.data;

      });
}

  getSeason() {
    let params = {
      start: 0,
      limit: 100,
      page: 1,
      date: this.datePipe.transform(new Date(), "yyyy"),
      type: "invoice",
    };
    this.salesinvservice.getCurrentSeason(params).then((res: any) => {
      if (res.success) {
        this.partyCtrl.setValue(this.invoicedata["season"]);
        this.invoicedata.season = res.data.season;
      } else {
        swal("PLEASE PUT THE SEASON FIRST!");
      }
    });
  }
  getTbodyStyle() {
    let height = 300;
    if (this.tbody1) {
      height -= this.tbody1.nativeElement.offsetHeight;
    }
    const style = {
      display: "block",
      width: "1px",
      height: height + "px",
      "overflow-y": "scroll",
    };
    return style;
  }
  SoStyle(ind) {
    if (this.data.invoiceList[ind].so === 'Non Ord') {
      return {
        color: "red",
        fontWeight: "800"
      };
    }
  }

  
  getBagBarcodeDetails(flag: string, event: any) {


    const params = {
      bag_barcode: this.invoicedata.bag_barcode,
      party_id: this.invoicedata.party_id,
      trans_type: 'counterdc'
    };



    if (this.invoicedata.bag_barcode.length != 8) {

      const [prefix, number] = this.invoicedata.bag_barcode.split('-');

      const requiredLength = 8;
      const dashLength = 1;
      const prefixLength = prefix.length;
      const paddedNumberLength = requiredLength - prefixLength - dashLength;

      // Pad the number with leading zeros
      const paddedNumber = number.padStart(paddedNumberLength, '0');

      // Final barcode
      this.invoicedata.bag_barcode = `${prefix}-${paddedNumber}`;


    }



    // Split into prefix and padded number
    let [prefix, paddedNumber] = params.bag_barcode.split('-');

    // Remove leading zeros
    let originalNumber = paddedNumber.replace(/^0+/, '');

    // Handle case like 'B3-000000' → 'B3-0'
    if (originalNumber === '') {
      originalNumber = '0';
    }

    // Combine back to short format
    let shortCode = `${prefix}-${originalNumber}`;

    const isExist = this.data.invoiceList.find((data) => data.bag_barcode == shortCode);
    if (!isExist) {

      this.salesinvservice.checkBarcode(params).then((res: any) => {
        if (this.page_type == "estimate" || this.page_type == "wholesale") {
          if (res.data.length == 0 && res.message == "Access Denied") {
            swal("ERROR", "<h2>INVOICE SCREEN ACCESS IS CLOSED !!</h2>", "error");

            this.invoicedata.barcode = "";
            return;
          }
        }

        if (res.data.length == 0) {
          //   swal("Selected Design is invalid!");
          swal({
            title: res.message,
            type: "warning",
            showCancelButton: false,
            showConfirmButton: false,
            timer: 2500,
          });

        }
        //For CheckIng Damage Pcs 
        else if (this.menu_name == 'Counter') {

          for (let index = 0; index < res.data.length; index++) {
            const el = res.data[index];

            let row = Object.assign(
              {
                f36: 0,
                f38: 0,
                f40: 0,
                f42: 0,
                f44: 0,
                f46: 0,
                h36: 0,
                h38: 0,
                h40: 0,
                h42: 0,
                h44: 0,
                h46: 0,
              },
              el
            );
            row[row.size.toLowerCase()] = 1;
            row.fqty = row.f36 + row.f38 + row.f40 + row.f42 + row.f44 + row.f46;
            row.hqty = row.h36 + row.h38 + row.h40 + row.h42 + row.h44 + row.h46;
            row.totqty = row.hqty + row.fqty;

            if (this.invoicedata.rate_type == "FLAT RATE") {
              row.rate = this.invoicedata.rate;
            }
            console.log(row, "beforeeeeeeeeeee")
            this.data.invoiceList.push(row);

          }
          this.invoicedata.bag_barcode = '';

          console.log(this.data.invoiceList, "after pushhhhhhhhhhhh")


           this.calcBox();
          this.calctot();
          var bottom = document.querySelector("#salesTbody");
          setTimeout(() => {
            bottom.scrollTop = bottom.scrollHeight;
          }, 300);

        }


      });
    }
    // else {
    //   this.errorSwal("Bag Barcode already exist");
    //   this.filter.bag_barcode = '';
    //   this.barcodeFocus(flag);
    // }


  }

  checkBarcode(code) {
    if (code.length == 7) {
      if (this.execApi) {
        this.execApi = false;
        let params = {
          barcode: code,
          party_id:  this.page_type == 'estimate' ? this.invoicedata.party_id : '',
          trans_type: this.page_type == 'LimitStock' ? 'LimitStock' : this.page_type == 'SizewiseStock' ? 'SizewiseStock' : this.page_type == 'tracking' ? 'tracking': this.page_type == 'barcode_active' ? 'barcode_active':'counterdc'
        };
        for (let i = 0; i < this.data.invoiceList.length; i++) {
          code = parseInt(code);
          this.data.invoiceList[i].barcode = parseInt(
            this.data.invoiceList[i].barcode
          );
          if (this.data.invoiceList[i].barcode == code) {
        
            setTimeout(() => {
              this.invoicedata.barcode = "";
              $("#code").focus();
            }, 500);

            swal({
              title: "Barcode Already Exists",
              timer: 1000,
              type: "warning",
              showCancelButton: false,
              showConfirmButton: false,
            });
            this.execApi = true;
            return;
          }      
        }
         
        this.salesinvservice.checkBarcode(params).then((res: any) => {
          if (this.page_type == "estimate" || this.page_type == "wholesale") {
            if (res.data.length == 0 && res.message == "Access Denied") {
              swal("ERROR", "<h2>INVOICE SCREEN ACCESS IS CLOSED !!</h2>", "error");
              this.execApi = true;
              this.invoicedata.barcode = "";
              return;
            }
          }

          if (res.data.length == 0) {
            //   swal("Selected Design is invalid!");
            swal({
              title: res.message,
              type: "warning",
              showCancelButton: false,
              showConfirmButton: false,
              timer: 2500,
            });
            let invalidData = {
              barcode: code,
              type: "invoice",
            };
            this.invalidList.push(invalidData);
            this.invoicedata.barcode = "";
            this.execApi = true;
            return;
          }
          //For CheckIng Damage Pcs 
          else if(res.data && !res.data.size && this.page_type !='tracking' && this.page_type !='barcode_active'){

            swal("ERROR", "<h2>DEFECT STOCK PCS !!</h2>", "error");
            this.execApi = true;
            return;
          }
          //For CheckIng Damage Pcs barcode
          else if( this.page_type =='tracking' && (res.data && res.data[0].dam_barcode)){
          
            swal("ERROR", "<h2>DEFECT STOCK PCS !!</h2>", "error");
            this.execApi = true;
            return;
          }


          else if(res.data.length > 0 && this.page_type == 'barcode_active'){
         swal({
              html:
              "<b>" + res.message.toUpperCase() + "</b>",
             });
            
             if(res.message != "Stock exists"){
              let rawdata = res.data.map(element => Object.keys(element).reduce((acc, key) => {
                acc[key.toLowerCase()] = element[key];
                return acc;
              }, {}));
              this.data.invoiceList.push(...rawdata);
             }
          this.execApi = true;
          return;
         }
          else if (res.data.length > 0 && this.page_type == 'tracking') {
            swal({
              title:
              res.data[0].stock_status.toUpperCase(),
              customClass: 'bar_track',
              html:
            "<b>" + res.data[0].party_name +
                "<br/>" +
                res.doc_type +
                res.data[0].dc_no +
                "<br/>" +
                " DATE - " +
                res.data[0].date_formated +
                "<br/>" + "</b>",
            });
            this.execApi = true;
            return
          }

          // if(this.menu_name == 'Counter'){
          //   if (this.bagged_pcs && !res.data.bag_id) {
          //     swal("ERROR", "<h2>Scan Only Bagged Shirt Item !!</h2>", "error");
          //     this.invoicedata.barcode = '';
          //     this.execApi = true;
          //     return;
          //   }
          //   if(this.bagged_pcs && (res.data.bag_id != this.bag_id )){
          //    swal("ERROR", `<h2>${res.data.bag_barcode}- It's Different Bag Pcs!!</h2>`, "error");
          //    this.invoicedata.barcode = '';
          //     this.execApi = true;
          //     return; 
          //   }
          //   this.bagged_pcs = (!this.bagged_pcs && res.data.bag_id) ? res.data.bagged_pcs : this.bagged_pcs;
          //   this.bag_id = (!this.bag_id && res.data.bag_id) ? res.data.bag_id : this.bag_id;

          // }
          let row = Object.assign(
            {
              f36: 0,
              f38: 0,
              f40: 0,
              f42: 0,
              f44: 0,
              f46: 0,
              h36: 0,
              h38: 0,
              h40: 0,
              h42: 0,
              h44: 0,
              h46: 0,
            },
            res.data
          );
          row[row.size.toLowerCase()] = 1;
          row.fqty = row.f36 + row.f38 + row.f40 + row.f42 + row.f44 + row.f46;
          row.hqty = row.h36 + row.h38 + row.h40 + row.h42 + row.h44 + row.h46;
          row.totqty = row.hqty + row.fqty;

          if (this.invoicedata.rate_type == "FLAT RATE") {
            row.rate = this.invoicedata.rate;
          }

          this.data.invoiceList.push(row);

          // if(this.menu_name == 'Counter' && this.bagged_pcs){
          //   this.bagged_pcs = this.bagged_pcs - 1;
          //   this.bag_id = (this.bagged_pcs > 0) ? this.bag_id : 0;
        
          // }

          var bottom = document.querySelector("#salesTbody");
          setTimeout(() => {
            bottom.scrollTop = bottom.scrollHeight;
          }, 300);

          this.calcBox();
          this.calctot();
          this.execApi = true;
          this.invoicedata.barcode = "";
        });

        console.log(this.row, "check dataaaaaa",this.data.invoiceList)
      }
    }
  }

  displayFn(comboType: string, id: number) {
    let list: any = [];
    let that = this;
    if (comboType == "Season") {
      list = this.seasonList;
    }

    if (id && list.length > 0) {
      let fitem = _.find(list, { season: id });
      this.invoicedata.season = fitem["season"];
      return fitem["season"];
    }
    return "";
  }
  bsModalRef: BsModalRef;

  onSaveDC(): void {
    if (
      (this.invoicedata.party_name == undefined ||
        this.invoicedata.season == undefined) && (this.page_type != 'LimitStock' && this.page_type != 'SizewiseStock')
     || (!this.invoicedata.scanned_by || !this.invoicedata.prepared_by) && (this.page_type !='LimitStock' && this.page_type !='SizewiseStock' && this.page_type !='tracking' && this.page_type !='barcode_active' && this.mode !='Inwarded')
    ) {
      swal("Make sure that All The Entries Filled");
    } else {
      let params: any = Object.assign({}, this.invoicedata);
      params["tabevent"] = undefined;
      params["boxless"] = 0;
      params["no_of_bundles"] = this.invoicedata.no_of_bundles || 0;
      params["salesorder"] = this.invoicedata.salesorder || false;
      params["dcinvoice"] = JSON.stringify(this.data.invoiceList);
      if (this.mode == "Convert") {
        params["estinvoice"] = JSON.stringify(this.listSelected);
      }
      params["del_party_id"] = "";
      params["dcdt"] = this.datePipe.transform(params["dcdt"], "yyyy-MM-dd");
      if (this.invoicedata.mode == "Convert") {
        params["mode"] = "Add";
        params["estimate_dcid"] = this.invoicedata.dcid;
        params["sales_type"] = this.to_sale_type;
      }
      if (
        this.page_type != "retail" &&
        this.invoicedata.mode !== "Convert" &&
        this.mode !== "Restore" &&
        this.mode !== 'Edit' && (this.page_type != 'LimitStock' && this.page_type != 'SizewiseStock')

      ) {
        let order = this.partyOrderno.filter((i) =>
          this.invoicedata.so_no.includes(i.so_no)
        );
        this.order = order[0]["order_type"];

        if (this.order == "Open Order") {
          params["soGrid"] = JSON.stringify(this.data.invoiceList);
          params["ES"] = "OPENORDERLIST";
          if (this.mode == "Edit") params["bl"] = JSON.stringify(this.bl);
        }
      }

      let that = this;

      swal({
        title: "Are you sure to save this Details?",
        type: "warning",
        showCancelButton: true,
        confirmButtonText: "Yes, save it!",
        cancelButtonText: "No, want to change",
      }).then(function () {
        that.isLoadMask = that.Salesservice
          .Savecounterdcentry(params)
          .then(function (res: any) {
            if (res.message == "Access Denied") {
              swal("ERROR", "<h2>INVOICE SCREEN ACCESS IS CLOSED !!</h2>", "error");
              return false
            }
            else {
              if (that.saveEvent) {
                that.saveEvent.emit();
              }
              if (res.success) {
                that.toasterService.pop({
                  bodyOutputType: 1,
                  type: "success",
                  title: "SUCCESS",
                  body: res.message,
                });
                if (that.mode == "Add") {
                  let tabObj = {
                    action: "CloseTab",
                    params: {},
                  };
                  that.tabUpdateEvent.emit(tabObj);
                } else {
                  let tabObj = {
                    action: "CloseTab",
                    params: {},
                  };
                  that.tabUpdateEvent.emit(tabObj);
                }
              if(res.dcid){
                let params = {
                  printType: "counterDCdetails",
                  party_id: res.party_id,
                  dcid: res.dcid,
                };
                that.salesinvservice.salesInvoicePrint(params).then((res: any) => {
                  // let var = "<div>aaaa</div>"
                  that.printData = res;
                  that.bsModalRef = that.modalService.show(PrintData, {
                    keyboard: false,
                    ignoreBackdropClick: true,
                    class: "compWidth-70",
                  });
                  that.bsModalRef.content.stkdata = Object.assign({}, params);
                  that.bsModalRef.content.printdet = that.printData;
                });
              }
              } else {
                if (that.mode == "Restore") {
                  swal("Sorry! You can only restore the last invoice...");
                } else {
                  swal("ERROR", res.message, "error");
                }
              }
            }
          })
          .catch(function (error: any) {
            let res = JSON.parse(error._body);
            swal("ERROR", res.message, "error");
          });
      });
    }
  }


  addCounterstock(): void {
    let params = {
      dcid: this.data.invoiceList[0].dcid
    }
    let that = this;

    swal({
      title: "Are you sure to Add Counter-Stock?",
      type: "warning",
      showCancelButton: true,
      confirmButtonText: "Yes, save it!",
      cancelButtonText: "No, want to change",
    }).then(function () {
      that.isLoadMask = that.Salesservice
        .addCounterstock(params)
        .then(function (res: any) {
          if (res.message == "Access Denied") {
            swal("ERROR", "<h2>INVOICE SCREEN ACCESS IS CLOSED !!</h2>", "error");
            return false
          }
          else {
            if (that.saveEvent) {
              that.saveEvent.emit();
            }
            if (res.success) {
              that.toasterService.pop({
                bodyOutputType: 1,
                type: "success",
                title: "SUCCESS",
                body: res.message,
              });
              if (that.mode == "Add") {
                let tabObj = {
                  action: "CloseTab",
                  params: {},
                };
                that.tabUpdateEvent.emit(tabObj);
              } else {
                let tabObj = {
                  action: "CloseTab",
                  params: {},
                };
                that.tabUpdateEvent.emit(tabObj);
              }
            } else {
              if (that.mode == "Restore") {
                swal("Sorry! You can only restore the last invoice...");
              } else {
                swal("ERROR", res.message, "error");
              }
            }
          }
        })
        .catch(function (error: any) {
          let res = JSON.parse(error._body);
          swal("ERROR", res.message, "error");
        });
    });

  }
  calcBox() {
    if (this.box == "YES") {
      this.invoicedata.boxless += 10;
    }
  }

  onSelectPartyName(name) {
    let partylist = _.filter(this.partyList, { name: name });

    if (this.mode == 'Edit') {
      return
    }
    // else if(this.mode == 'Edit'){

    // }
    else if (this.mode != "Convert") {
      // this.invoicedata.agent_id = partylist[0]["agent_id"];
      this.invoicedata.party_id = partylist[0]["genLedid"];
      this.invoicedata.disper = 0;

      // if (partylist[0]["disc_applicable"] == 'YES') {
      //   this.invoicedata.disper = partylist[0]["discount"];
      // }

      this.invoicedata.pack_style = partylist[0]["pack_style"];
    }
    this.box = partylist[0]["boxless"];

    if (this.mode == "Add") {
      if (this.page_type == "retail") {
        $("#customer_name").focus();
      } else {
        $("#so_no").focus();
      }
    }

    let params = {
      party_id: this.invoicedata.party_id,
      party_name: name,
      season: this.invoicedata.season,
    };
    this.salesinvservice.getPartyOrderNumber(params).then((res: any) => {
      this.partyOrderno = res;
    });
  }
  // saveOpenOrderDetails(){
  //     let params: any = Object.assign({}, this.invoicedata);
  //     params['tabevent'] = undefined;
  //     params['mode'] = this.mode;
  //     params['soGrid'] = JSON.stringify(this.data.invoiceList);
  //     params['ES'] = 'OPENORDERLIST';

  //         this.isLoading = true;
  //         this.salesservice
  //             .adduptSalesOrder(params)
  //             .then((res: any) => {
  //             });

  // }
  editInvoiceList() {
    let params = {
      start: 0,
      limit: 100,
      page: 1,
      dcid: this.invoicedata.dcid,
    };
    this.Salesservice.getcounterdcList(params).then((res: any) => {
      this.data.invoiceList = res.data;
      this.calctot();
      var bottom = document.querySelector("#salesTbody");
      bottom.scrollTop = bottom.scrollHeight;
    });
  }
  barcodeList() {
    let params = {
      start: 0,
      limit: 100,
      page: 1,
      dcid: this.invoicedata.dcid,
    };
    this.salesinvservice.getBarcodeOpenOrder(params).then((res: any) => {
      this.bl = res.data;
    });
  }
  oncheck(ischeck) {
    if (ischeck == true || ischeck == "true") {
      this.invoicedata.salesorder = true;
    } else {
      this.invoicedata.salesorder = false;
    }
  }

  calctot() {
    let ftot = 0,
      htot = 0,
      tot = 0;
    for (let i = 0; i < this.data.invoiceList.length; i++) {
      ftot += parseInt(this.data.invoiceList[i]["fqty"]);
      this.invoicedata.ftotal = ftot;
      htot += parseInt(this.data.invoiceList[i]["hqty"]);
      this.invoicedata.htotal = htot;
      tot += parseInt(this.data.invoiceList[i]["totqty"]);
      this.invoicedata.total = tot;
    }
  }
}



// WEBPACK FOOTER //
// /Users/afsarahamed/Documents/symatis/projects/hyatt-angularweb/src/app/components/report/SalesOrderReports/designSoReport/addcounterDC.ts